export const MaxSiteLogoImageFileSizeBytes: number = 2097152;
